( function () {
    'use strict';
    espresso.util = {};
    // Open all links tagged with 'newwindow' in a new window
    espresso.util.openLinksInNewWindow = function () {
        var jLinks = jQuery( 'a.newwindow' );
        if ( jLinks.length > 0 ) {
            jLinks.on( 'click', function ( event ) {
                event.preventDefault();
                window.open( this.href );
            } );
        }
    };
    // Vis overlay der passer p&aring; gridet
    espresso.util.toggleGridOverlay = function () {
        jQuery( 'a[href$="toggle-grid-overlay"]' ).on( 'click', function ( event ) {
            event.preventDefault();
            var jGrid = jQuery( '#e-grid' );
            jGrid.toggle().closest( '.e-content' ).css( {
                position: jGrid.is( ':visible' ) ? 'relative' : 'static'
            } );
        } );
    };
    // Tilføj produkter og nyheder til breadcrumbs
    espresso.util.appendPageToBreadcrumb = function () {
        var jBreadcrumb = jQuery( '.breadcrumb' ).filter( ':visible' );
        if ( jBreadcrumb.is( '.visible-phone' ) ) {
            jBreadcrumb.find( 'li:last-child' ).text( jQuery( '.js-e-breadcrumb-link-text' ).text() );
        }
        else {
            var jBreadcrumbNewItem = jBreadcrumb.find( 'li' ).last().clone();
            if ( jBreadcrumbNewItem.find( '.divider' ).length === 0 ) {
                jBreadcrumbNewItem.prepend( '<span class="divider">/</span>' );
            }
            jBreadcrumbNewItem.find( 'a' ).attr( 'href', jQuery( '.js-e-breadcrumb-link-url' ).text() ).find( 'span' ).text( jQuery( '.js-e-breadcrumb-link-text' ).text() );
            jBreadcrumb.append( jBreadcrumbNewItem );
        }
    };
    //Add animation entry to images and/or paragraphs
    espresso.util.animateParagraphEntry = function () {
        var jParagraphsToAnimate = jQuery( '.animate, .fade' ).removeClass( 'animate fade' ).closest( '[class*="span"]' ).addClass( 'animate' ),
            isAboutToFire = false,
            eventThreshold = ( ( navigator.userAgent.toLowerCase().indexOf( 'mac os' ) !== -1 ) ? 10 : 100 );
        espresso.constant.jWindow.on( 'scroll resize', function () {
            if ( isAboutToFire ) {
                clearTimeout( isAboutToFire );
            }
            isAboutToFire = setTimeout( function () {
                var animateIndex = 0;
                jParagraphsToAnimate.each( function ( index ) {
                    var jThis = jParagraphsToAnimate.eq( index );
                    if ( jThis.is( '.animate-triggered' ) === false && espresso.util.isInViewport( jThis ) === true ) {
                        jThis.addClass( 'animate-triggered' );
                        setTimeout( function () {
                            jThis.addClass( 'fadeIn' ).addClass( 'animate-show' );
                            jParagraphsToAnimate.splice( jParagraphsToAnimate.index( jThis ), 1 );
                        }, animateIndex * 100 );
                        animateIndex++;
                    }
                } );
            }, isAboutToFire ? eventThreshold : 1 );
        } ).triggerHandler( 'scroll' );
    };
    espresso.util.isInViewport = function ( jElm ) {
        var viewportTop = espresso.constant.jWindow.scrollTop(),
            viewportBottom = viewportTop + espresso.constant.jWindow.height(),
            elmTop = jElm.offset().top,
            elmBottom = elmTop + jElm.height();
        return ( elmTop <= viewportBottom && elmBottom >= viewportTop );
    };
}() );
